import { render, staticRenderFns } from "./baozhiqi.vue?vue&type=template&id=6a29556e&scoped=true&"
import script from "./baozhiqi.vue?vue&type=script&lang=js&"
export * from "./baozhiqi.vue?vue&type=script&lang=js&"
import style0 from "./baozhiqi.vue?vue&type=style&index=0&id=6a29556e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a29556e",
  null
  
)

export default component.exports